import React, {useState, useEffect, useContext} from "react";
import * as Sentry from '@sentry/browser';
import {FormattedMessage} from "react-intl";
import Api from "../../Api";
import {withAuth} from "../../hoc/Auth";
import {Column, Container, Wrapper} from "../../hoc/Layout";
import EmptyCard from "../../hoc/EmptyCard";
import RegistryControls from "../../Components/RegistryControls";
import RegistryUploadInfo from "../../Components/RegistryUploadInfo"
import RegistryDADUpload from "../../Components/RegistryDADUpload";
import RegistryColumnsHelp from "../../Components/RegistryColumnsHelp";
import RegistryInfoCard, {NoTerminalsForMethod, WrongRegistryTypeHint} from "../../Components/RegistryInfoCard";
import {filterTerminalsByMethod, PAYOUT_METHOD_SBP} from "../../Services/payoutMethods";
import {Select} from "../../Components/Utils/FieldsHelper";

import classes from "./styles.module.css"

import Context from "../../Context";
import MessageContext from "../../MessageContext";

const MobileRegistryUpload = withAuth(({token}) => {

        const [projectUUID, setProjectUUID] = useState(null);
        const [providerUUID, setProviderUUID] = useState(null);

        const [selectedProject, setSelectedProject] = useState(null);
        const [selectedTerminal, setSelectedTerminal] = useState(null);

        const [initRegistry, setInitRegistry] = useState([])
        const [filteredRegistry, setFilteredRegistry] = useState([])
        const [initRegistryName, setInitRegistryName] = useState('')
        const [registryName, setRegistryName] = useState('')
        const [registryAmount, setRegistryAmount] = useState(0);

        const [projects, setProjects] = useState([]);
        const [terminals, setTerminals] = useState([]);

        const [commission, setCommission] = useState(0);

        const [errorsCount, setErrorsCount] = useState(0);
        const [errorsList, setErrorsList] = useState([]);
        const [errorsFormat, setErrorsFormat] = useState(false);
        // «Похоже, это карточный реестр» — подсказка приходит с бэкенда
        // вместе с ошибкой формата, разбор шапки живёт рядом с загрузчиком.
        const [wrongRegistryType, setWrongRegistryType] = useState(null);
        const [wrongRegistryHint, setWrongRegistryHint] = useState(null);
        const [tags, setTags] = useState([]);
        const [suggestionsTags, setSuggestionsTags] = useState([]);
        const [terminalBalance, setTerminalBalance] = useState({balance: 0, currency: "RUB"});

        const [loadingRegistry, setLoadingRegistry] = useState(false);
        const [loadingProjects, setLoadingProjects] = useState(true);
        const [loadingTerminals, setLoadingTerminals] = useState(false);

        const [isRequest, setIsRequest] = useState(false);

        const {onMessage} = useContext(MessageContext);

    useEffect(() => {
        setLoadingProjects(true);

        new Api({ token })
            .getProjects()
            .then((r) => {
                setProjects(Array.isArray(r) ? r : []);
            })
            .catch((err) => {
                Sentry.captureException(err);
                setProjects([]);
                onMessage({ type: "error", message: "Не удалось загрузить список проектов." });
            })
            .finally(() => {
                setLoadingProjects(false);
            });
    }, [token]);

    function calcCommission(rows, payoutFee) {
        if (!Array.isArray(rows) || rows.length === 0) {
            setCommission(0);
            return;
        }

        if (!payoutFee || typeof payoutFee !== "object") {
            setCommission(0);
            return;
        }

        var cost = Number(payoutFee.cost != null ? payoutFee.cost : 0);
        var min = Number(payoutFee.costFixedMinimum != null ? payoutFee.costFixedMinimum : 0);
        var fixed = Number(payoutFee.fixedPerTransaction != null ? payoutFee.fixedPerTransaction : 0);

        var total = 0;

        rows.forEach(function (el) {
            var amountRaw = el && el.row ? el.row.amount : 0;
            var a = Number(amountRaw);

            if (!isFinite(a) || a <= 0) return;

            var pct = a * (cost / 100);
            total += (pct < min ? min : pct) + fixed;
        });

        setCommission(total);
    }

        function onChangeRegistryName(value) {
            setRegistryName(value.replace(/[^A-Za-zА-Яа-я0-9\s-_!?=.]+/g, ''));
        }

        function onSelectProject(project) {
            setProjectUUID(project.uuid);
            setSelectedTerminal(null);
            setProviderUUID(null);
            setSelectedProject(project);
            setLoadingTerminals(true);

            if (project.uuid) {
                new Api({token}).getTags(project.uuid).then(
                    (r) => {
                        setSuggestionsTags(r);
                    }
                )
            }

            new Api({token}).getProjectData(project.uuid).then(
                (r) => {
                    // Только терминалы, умеющие выплату через СБП: карточный
                    // терминал по номеру телефона не заплатит, а страница до
                    // отказа успеет попросить у мерчанта телефоны и банки.
                    // Фильтруем ДО проверки «терминал единственный».
                    const usableTerminals = filterTerminalsByMethod(r.terminals, PAYOUT_METHOD_SBP);

                    if (usableTerminals.length === 1) {
                        const t = usableTerminals[0];
                        setTerminalBalance({ balance: t.balance.confirmed, currency: t.currency });
                        setProviderUUID(t.uuid);
                        setSelectedTerminal(t);

                        if (Array.isArray(initRegistry) && initRegistry.length > 0) {
                            calcCommission(initRegistry, t.fee ? t.fee.payout : null);
                        } else {
                            setCommission(0);
                        }
                    } else {
                        setCommission(0);
                    }

                    setTerminals(usableTerminals);
                    setLoadingTerminals(false);
                }
            )
        }

    function onSelectTerminal(terminal) {
        setSelectedTerminal(terminal);
        setProviderUUID(terminal.uuid);
        setTerminalBalance({ balance: terminal.balance.confirmed, currency: terminal.currency });

        if (Array.isArray(initRegistry) && initRegistry.length > 0) {
            calcCommission(initRegistry, terminal.fee ? terminal.fee.payout : null);
        } else {
            setCommission(0);
        }
    }

        function onSelectedTag(tags) {
            setTags(tags);
        }

        function setFilterErrors(val) {
            if (val) {
                const filteredData = initRegistry.filter(function (e) {
                    return e.hasError;
                });
                setFilteredRegistry(filteredData);
            } else {
                setFilteredRegistry([]);
            }
        }

        function submitRegistry() {
            if (!providerUUID || !projectUUID) {
                onMessage({type: 'warning', message: 'Для отправки реестра выберите терминал.'})
                return false;
            }

            setIsRequest(true);

            const registry = [];
            let name;

            initRegistry.forEach(function (item) {
                registry.push(item.row);
            });

            if (registryName) {
                name = registryName;
            } else {
                name = initRegistryName;
            }

            new Api({token}).mobileRegistryProcess({registry: registry, tags, name, providerUUID}, projectUUID).then(
                function (r) {
                    if (r.result === "ok") {
                        clearRegistry();
                        setIsRequest(false);
                        onMessage({type: "success", message: "Мобильный реестр отправлен в очередь выплат."});
                    } else {
                        onMessage({type: "error", message: +('code: ' + r.code)});
                        setLoadingRegistry(false);
                    }
                }
            );
        }

        function clearRegistry() {
            setInitRegistry([]);
            setFilteredRegistry([]);
            setLoadingRegistry(false);
            setRegistryAmount(0);
            setCommission(0);
            setRegistryName('');
            setInitRegistryName('');
        }

    function processUploadedData(file, data) {
        var cleanName = file.name.replace(/[^A-Za-zА-Яа-я0-9\s-_!?=.]|\.xlsx+/g, '');
        setInitRegistryName(cleanName);
        setRegistryName(cleanName);

        var rows = (data && Array.isArray(data.data)) ? data.data : [];

        if (rows.length > 0) {
            var amount = 0;
            rows.forEach(function (el) {
                var v = el && el.row ? el.row.amount : 0;
                amount += Number(v) || 0;
            });

            setRegistryAmount(amount);
            setInitRegistry(rows);
            setFilteredRegistry(rows);
            setLoadingRegistry(true);

            var payoutFee = selectedTerminal && selectedTerminal.fee ? selectedTerminal.fee.payout : null;
            calcCommission(rows, payoutFee);
        } else {
            setLoadingRegistry(false);
            setRegistryAmount(0);
            setInitRegistry([]);
            setFilteredRegistry([]);
            setCommission(0);
        }

        if (data && data.errors) {
            if (data.errors.count) {
                setErrorsCount(data.errors.count);
                setErrorsList(data.errors);
            } else {
                setErrorsCount(0);
            }
            if (data.errors.formatError) {
                setErrorsFormat(true);
            }

            setWrongRegistryType(data.errors.wrongRegistryType || null);
            setWrongRegistryHint(data.errors.wrongRegistryHint || null);
        } else {
            setWrongRegistryType(null);
            setWrongRegistryHint(null);
        }
    }

    function mobileUploadFn(file) {
        var formData = new FormData();
        formData.append("file", file);
        return new Api({token}).mobileRegistryUpload(formData, projectUUID);
    }

    function onMobileRegistryUpload(file, data) {
        processUploadedData(file, data);
    }

    // Таблица мобильного реестра
    function renderMobileTable(data) {
        if (!data || data.length === 0) return null;

        return (
            <table style={{width: '100%', borderCollapse: 'collapse', fontSize: '13px'}}>
                <thead>
                <tr style={{borderBottom: '2px solid #ddd', textAlign: 'left'}}>
                    <th style={{padding: '8px'}}>
                        <FormattedMessage id="MobileRegistry.table.phone" defaultMessage="Телефон"/>
                    </th>
                    <th style={{padding: '8px'}}>
                        <FormattedMessage id="MobileRegistry.table.bic" defaultMessage="БИК / ID банка"/>
                    </th>
                    <th style={{padding: '8px'}}>
                        <FormattedMessage id="MobileRegistry.table.cardHolderRu" defaultMessage="ФИО"/>
                    </th>
                    <th style={{padding: '8px'}}>
                        <FormattedMessage id="MobileRegistry.table.amount" defaultMessage="Сумма"/>
                    </th>
                    <th style={{padding: '8px'}}>
                        <FormattedMessage id="MobileRegistry.table.documentNumber" defaultMessage="Номер док."/>
                    </th>
                    <th style={{padding: '8px'}}>
                        <FormattedMessage id="MobileRegistry.table.documentDate" defaultMessage="Дата док."/>
                    </th>
                </tr>
                </thead>
                <tbody>
                {data.map((el, index) => {
                    const row = el.row || {};
                    const rowStyle = el.hasError ? {backgroundColor: '#fde1df'} : {};

                    return (
                        <tr key={index} style={{...rowStyle, borderBottom: '1px solid #eee'}}>
                            <td style={{padding: '8px'}}>{row.phone}</td>
                            <td style={{padding: '8px'}}>{row.bic}</td>
                            <td style={{padding: '8px'}}>{row.cardHolderRu || row.cardholder_name}</td>
                            <td style={{padding: '8px'}}>{row.amount}</td>
                            <td style={{padding: '8px'}}>{row.documentNumber || row.document_number || ''}</td>
                            <td style={{padding: '8px'}}>{row.documentDate || row.document_date || ''}</td>
                        </tr>
                    );
                })}
                </tbody>
            </table>
        );
    }

    return (
            <Wrapper>
                <Context.Provider value={{
                    setFilterErrors,
                    onSelectedTag,
                    onChangeRegistryName,
                    submitRegistry,
                    clearRegistry
                }}>

                    <Container className={classes.StackOnMobile}>
                        <Column width="780" className={classes.MainColumn}>
                            {loadingRegistry ?
                                <div className={classes.Card}>
                                    {renderMobileTable(filteredRegistry.length > 0 ? filteredRegistry : initRegistry)}
                                </div>
                                :
                                <React.Fragment>
                                    <RegistryDADUpload
                                        token={token}
                                        onRegistryUpload={onMobileRegistryUpload}
                                        merchantUuid={projectUUID}
                                        hint="Формат: телефон, банк, ФИО, сумма (XLSX/CSV)"
                                        uploadFn={mobileUploadFn}
                                    />
                                    <WrongRegistryTypeHint
                                        wrongType={wrongRegistryType}
                                        hint={wrongRegistryHint}
                                    />
                                    <RegistryColumnsHelp
                                        token={token}
                                        type="sbp"
                                        provider={selectedTerminal ? selectedTerminal.processing : null}
                                    />
                                </React.Fragment>
                            }
                        </Column>

                        <Column width="350" className={classes.SideColumn}>
                            <RegistryUploadInfo name={initRegistryName} errorsCount={errorsCount}
                                                errorsList={errorsList} errorsFormat={errorsFormat}
                                                balance={terminalBalance} amount={registryAmount} fee={commission}/>

                            <EmptyCard>
                                <Select
                                    label={"FieldsHelper.label.project"}
                                    placeholder={"FieldsHelper.label.selectProject"}
                                    isLoading={loadingProjects}
                                    values={projects}
                                    onChange={onSelectProject}
                                    selectedValue={selectedProject}
                                    isClean={false}
                                    fieldName={"displayName"}
                                    fieldStatus={"status"}
                                />

                                {selectedProject && (
                                    <RegistryInfoCard
                                        variant="project"
                                        project={selectedProject}
                                        terminals={terminals}
                                    />
                                )}

                                <Select
                                    label={"FieldsHelper.label.terminal"}
                                    placeholder={"FieldsHelper.label.selectTerminal"}
                                    isLoading={loadingProjects || !selectedProject || loadingTerminals}
                                    values={terminals}
                                    onChange={onSelectTerminal}
                                    selectedValue={selectedTerminal}
                                    isClean={false}
                                    fieldName={"name"}
                                    fieldStatus={"enabled"}
                                />

                                {selectedTerminal && (
                                    <RegistryInfoCard
                                        variant="terminal"
                                        terminal={selectedTerminal}
                                        currentMethod="sbp"
                                    />
                                )}

                                {selectedProject && !loadingTerminals && terminals.length === 0 && (
                                    <NoTerminalsForMethod currentMethod="sbp"/>
                                )}
                            </EmptyCard>

                            {loadingRegistry && <RegistryControls
                                errorsCount={errorsCount}
                                suggestionsTag={suggestionsTags}
                                registryFileName={registryName}
                                amount={registryAmount}
                                fee={commission}
                                balance={terminalBalance}
                                isLoading={isRequest}
                            />}
                        </Column>
                    </Container>
                </Context.Provider>
            </Wrapper>
        )
    }
)

export default MobileRegistryUpload;



// WEBPACK FOOTER //
// ./src/PagesOfUser/MobileRegistryUpload/index.js